import { destroyChart } from '@/lib/utils/destroyChart'
import type Highcharts from 'highcharts'
import { Chart } from 'highcharts-vue'
import { App, defineComponent } from 'vue'

// highcharts-vue 2.0.2's registered component never destroys its chart on unmount
// (see src/lib/utils/destroyChart.ts for why). This local plugin registers a component
// that extends highcharts-vue's own `Chart` and adds the missing `beforeUnmount` cleanup,
// so every `<highcharts>` mount in the app and in Storybook is covered from one place.
export const HighchartsChart = defineComponent({
  name: 'Highcharts',
  extends: Chart,
  beforeUnmount() {
    destroyChart((this as unknown as { chart?: Highcharts.Chart }).chart)
  }
})

export function install(app: App): void {
  app.component('highcharts', HighchartsChart)
}

export default install
